import { useContext } from 'react';
import { NotificationContext } from '@providers/NotificationProvider.tsx';

export const useNotify = () => {
    const context = useContext(NotificationContext);

    if (!context) {
        throw new Error('useNotify must be used within NotificationProvider');
    }

    return context.notify;
};
